/*----- AUTH users -------------------------------------------------------------------*/
export default {
  error: { message: "" },
  status: "",
  current_user: JSON.parse(localStorage.getItem("currentUser")) || {
    roles: [],
    permissions: [],
    image: ""
  },
  token: localStorage.getItem("auth_token") || null
};
